import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { CookiesMap } from '@sentecacommerce-theme/lib'
import { Typography, CheckboxSlider, Button } from '../../../Common'

export const AdvancedConsent = ({
  setDetails,
  moreInfo,
  acceptAll,
  saveChanges,
  cookiesMap,
  onSave,
  onAcceptAll,
  handleToggle,
  isChecked,
}: {
  setDetails: (key: string) => void
  moreInfo: string
  acceptAll: string
  saveChanges: string
  handleToggle: (name: string) => void
  onSave: () => void
  onAcceptAll: () => void
  isChecked: {}

  cookiesMap: CookiesMap
}) => {
  const renderCookies = (): ReactNode => {
    if (cookiesMap) {
      const cookies = Object.keys(cookiesMap)

      return cookies.map((cookie) => (
        <Content key={cookiesMap[cookie].key}>
          <div className="d-flex justify-content-between align-items-center">
            <Title>{cookie}</Title>
            <CheckboxSlider
              onChange={() => handleToggle(cookie)}
              isChecked={cookiesMap[cookie].isRequired || isChecked[cookie]}
              isRequired={cookiesMap[cookie].isRequired}
            />
          </div>
          <Description>{cookiesMap[cookie].description}</Description>
          <MoreInfo onClick={() => setDetails(cookie)}>{moreInfo}</MoreInfo>
        </Content>
      ))
    }
    return null
  }

  return (
    <Wrapper>
      <Categories>{renderCookies()}</Categories>
      <Buttons>
        <StyledButton bordered borderRadius="small" onClick={onAcceptAll}>
          <span>{acceptAll}</span>
        </StyledButton>
        <StyledButton borderRadius="small" variant="green" onClick={onSave}>
          <span>{saveChanges}</span>
        </StyledButton>
      </Buttons>
    </Wrapper>
  )
}

const Wrapper = styled.div.attrs({
  className: 'd-flex flex-column',
})`
  min-height: 59rem;
`
const Content = styled.div.attrs({
  className: 'my-lg-3 my-2 mx-lg-3 p-2',
})`
  position: relative;
  width: 100%;
  font-size: 1.3rem;
  background: ${({ theme }) => theme.palette.lightergrey};
  min-height: 15rem;

  border-radius: 1rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    font-size: 16px;
    width: 30%;
    min-height: 20rem;
    max-height: 20rem;
  }
`
const Categories = styled.span.attrs({
  className: 'd-flex flex-column flex-lg-row flex-wrap ',
})``

const Title = styled(Typography).attrs({
  variant: 5,
  className: 'my-1',
})`
  font-weight: 600;
`

const Description = styled.div.attrs({})`
  overflow: auto;
  max-height: 8rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    max-height: 13rem;
  }
`

const MoreInfo = styled(Typography).attrs({
  className: '',
  variant: 6,
})`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.primary};
`

const Buttons = styled.span.attrs({
  className: 'd-flex flex-column flex-lg-row mt-auto align-self-lg-end',
})``

const StyledButton = styled(Button).attrs({
  className: 'mt-3 mx-lg-2',
})`
  width: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    min-width: fit-content;
  }
`
